import { useNavigate } from "react-router";

export const ForbiddenPage = () => {
    const navigate = useNavigate()
    return (
        <div style={{display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh'}}>
            <div style={{textAlign: 'center'}}>
                <h1 style={{color: 'black', fontSize: '24px', fontWeight: 'bold', textAlign: 'center'}}>403 Forbidden</h1>
                <p style={{marginBottom: '1rem'}}>You are not authorized to access this page.</p>
                <button onClick={() => navigate('/')} style={{backgroundColor: 'green', color: 'white', width: '100px'}}>Go Back</button>
            </div>
        </div>
    )
}